import React from 'react';

const SecurityTab = ({ onChangePassword, couple, onUpdatePrivacy }) => {
  const handlePrivacyToggle = async (newValue) => {
    if (window.confirm(
      newValue 
        ? '¿Querés hacer tu lista pública? Aparecerá en la sección "Explorar bodas".'
        : '¿Querés hacer tu lista privada? Solo podrán acceder con el link directo.'
    )) {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch('https://gift-update-privacy-336444799661.us-central1.run.app', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ isPublic: newValue })
        });

        const data = await response.json();

        if (data.success) {
          onUpdatePrivacy(newValue);
          alert(newValue ? '✅ Tu lista ahora es pública' : '✅ Tu lista ahora es privada');
        } else {
          alert('❌ Error: ' + data.error);
        }
      } catch (error) {
        console.error('Error updating privacy:', error);
        alert('❌ Error al actualizar la configuración');
      }
    }
  };

  return (
    <div className="space-y-6 animate-fade-in max-w-3xl mx-auto">
      {/* Header */}
      <div className="card p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-2xl font-display font-bold text-neutral-900">
              Seguridad y Privacidad
            </h2>
            <p className="text-neutral-600 mt-2">
              Administrá la privacidad y seguridad de tu cuenta.
            </p>
          </div>
          <div className="text-3xl">🔐</div>
        </div>
      </div>

      {/* ✅ NUEVO: Lista pública/privada */}
      <div className="card p-6">
        <div className="flex items-start justify-between gap-4 mb-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-neutral-900 mb-2 flex items-center gap-2">
              <span>🌐</span> Lista pública
            </h3>
            <p className="text-neutral-600 text-sm">
              Si activás esta opción, tu lista aparecerá en la página de "Explorar bodas" 
              donde cualquier persona puede encontrarla por fecha. 
              Si preferís mantenerla privada, solo podrán acceder quienes tengan el link directo 
              o busquen tu nombre completo.
            </p>
          </div>

          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input
              type="checkbox"
              checked={couple?.isPublic !== false}
              onChange={(e) => handlePrivacyToggle(e.target.checked)}
              className="sr-only peer"
            />
            <div className="w-14 h-8 bg-neutral-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-accent-100 rounded-full peer peer-checked:after:translate-x-6 peer-checked:after:border-white after:content-[''] after:absolute after:top-1 after:left-1 after:bg-white after:border-neutral-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-accent-500"></div>
          </label>
        </div>

        <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
          <p className="text-xs text-blue-800">
            💡 <strong>Tip:</strong> Aunque tu lista sea privada, cualquiera que tenga el link directo podrá acceder. 
            La configuración solo afecta si aparece en la página de exploración pública.
          </p>
        </div>
      </div>

      {/* Cambiar contraseña */}
      <div className="card p-6">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-neutral-900 mb-2 flex items-center gap-2">
              <span>🔒</span> Cambiar contraseña
            </h3>
            <p className="text-neutral-600 text-sm">
              Recomendamos actualizarla periódicamente para mantener tu cuenta segura.
            </p>
          </div>

          <button
            onClick={onChangePassword}
            className="btn-primary whitespace-nowrap"
          >
            Cambiar contraseña
          </button>
        </div>
      </div>
    </div>
  );
};

export default SecurityTab;